import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
import Dashboard from '@/views/dashboard/index'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    children: [{
      path: '',
      redirect: '/dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '助听器管理系统' }
    }
    ]
  },
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '我的主页', icon: 'international', affix: true }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  }

]
export default new Router({
  routes: constantRoutes
})

export const asyncRoutes = [
  {
    path: '/user',
    component: Layout,
    name: 'Usermain',
    redirect: '/user/index',
    meta: { title: '用户管理', icon: 'edit', affix: true },
    children: [
      {
        path: '/user/index',
        name: 'User',
        component: () => import('@/views/User/userlist'),
        meta: { title: '用户列表', affix: true }
      },
      {
        path: '/user/index/userinfo/:id',
        name: 'Userindexinfo',
        component: () => import('@/views/User/userinfo'),
        meta: { title: '用户详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    name: 'Statisticsmain',
    redirect: '/statistics/index',
    meta: { title: '统计管理', icon: 'edit', affix: true },
    children: [
      {
        path: '/statistics/index',
        name: 'Statistics',
        component: () => import('@/views/Statistics/index'),
        meta: { title: '数据统计', affix: true }
      }
    ]
  },
  {
    path: '/Userfeedback',
    component: Layout,
    name: 'Userfeedback',
    redirect: '/Userfeedback/feedbacklist',
    meta: { title: '用户反馈', icon: 'edit', affix: true },
    children: [
      {
        path: '/Userfeedback/feedbacklist',
        name: 'feedbacklist',
        component: () => import('@/views/Userfeedback/feedbacklist'),
        meta: { title: '用户反馈', affix: true }
      },
      {
        path: '/Userfeedback/userbackinfo/:id',
        name: 'userbackinfo',
        component: () => import('@/views/Userfeedback/userbackinfo'),
        meta: { title: '反馈详情' },
        hidden: true
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js